/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1055
 */

module.exports = {
  buttonTypeIconBox: "IconSelectionBox_buttonTypeIconBox__1RyPU",
  svgIcon: "IconSelectionBox_svgIcon__1_puO",
  iconDropdown: "IconSelectionBox_iconDropdown__2RbJd"
}
